import React from 'react'
import { ReactSVG } from 'react-svg'
import {
  LoginBackground,
  LoginCard,
  LoginContainer,
  LoginLogo,
} from './Login.styles'
import wayboxLogo from '../../assets/waybox-logo.svg'
import { ExpiredTokenForm } from './ExpiredTokenForm'

export const ExpiredToken = () => {
  return (
    <LoginBackground>
      <LoginContainer>
        <LoginCard elevation={2}>
          <LoginLogo>
            <ReactSVG src={wayboxLogo} alt="waybox logo" />
          </LoginLogo>
          <ExpiredTokenForm />
        </LoginCard>
      </LoginContainer>
    </LoginBackground>
  )
}
